import Dropzone from "react-dropzone";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(() => ({
  dropzone: {
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
    padding: "10px",
    borderRadius: "5px",
    height: "100px",
    width: "500px",
    cursor: "pointer"
  },
  dropzoneActive: {
    boxShadow: "green 0px 7px 29px 0px;"
  }
}));

export default function DropZone({ disabled, onFilesDropped, dropzoneLabel, accept }) {
  const [uploading, setUploading] = React.useState(false);
  const [fileEnter, setFileEnter] = React.useState(false);

  const classes = useStyles();

  const onFileDrop = async (files) => {
    setUploading(true);
    try {
      await onFilesDropped(files);
    } finally {
      setUploading(false);
      setFileEnter(false);
    }
  };

  return (
    <div>
      <Dropzone
        accept={accept || ".txt,.pdf,.png,.jpg,.jpeg,.heif,.heic,.hevc,.doc,.docx"}
        onDragEnter={() => setFileEnter(true)}
        onDragLeave={() => setFileEnter(false)}
        disabled={disabled || uploading}
        onDrop={onFileDrop}
        multiple={true}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <div
              className={[
                classes.dropzone,
                fileEnter ? classes.dropzoneActive : ""
              ].join(" ")}
              {...getRootProps()}
            >
              <input {...getInputProps()} />
              {uploading ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <CircularProgress size={24} />
                  <p>Uploading files...</p>
                </div>
              ) : (
                <p>
                  {dropzoneLabel ||
                    "Drag & drop documents here (PDF, PNG, JPG, HEIC, TXT, DOC, DOCX)"}
                </p>
              )}
            </div>
          </section>
        )}
      </Dropzone>
    </div>
  );
}
